// extracted by mini-css-extract-plugin
module.exports = {"OverlayLink":"OverlayLink_OverlayLink__3Z0mL","debug":"OverlayLink_debug__30w2H"};